import { Accordion } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useState } from "react";
import MantineComponents from "storybook/MantineComponents";
import Tyopography from "storybook/Typography";

const Dashboard = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const xIcon = <IconX size={20} />;
  const checkIcon = <IconCheck size={20} />;
  const [loading, { toggle }] = useDisclosure();
  const [active, setActive] = useState(1);
  const nextStep = () =>
    setActive((current) => (current < 3 ? current + 1 : current));
  const prevStep = () =>
    setActive((current) => (current > 0 ? current - 1 : current));
  return (
    <>
      <Accordion defaultValue="Typography">
        <Accordion.Item key={"Typography"} value={"Typography"}>
          <Accordion.Control icon={"🍌"}>{"Typography"}</Accordion.Control>
          <Accordion.Panel>
            <Tyopography />
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item key={"Components"} value={"Components"}>
          <Accordion.Control icon={"🍌"}>{"Components"}</Accordion.Control>
          <Accordion.Panel>
            <MantineComponents />
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
export default Dashboard;
// This component serves as the dashboard page of the application.
// It displays a welcome message and can be extended with more dashboard-specific content.
// You can add charts, statistics, or any other relevant information here.
// The dashboard is typically used by administrators or users with special permissions to view system metrics or manage content.
// You can also integrate components like charts, tables, or other widgets to display relevant data.
// The dashboard is a central place for users to get an overview of the application's status or their own activities.
// You can also integrate components like charts, tables, or other widgets to display relevant data.
